__turbopack_context__.v({
  "menuWrapper": "AccountMenu-module-scss-module__rUCWXG__menuWrapper",
});
